import {ChangeDetectionStrategy, Component} from '@angular/core';
import {AuthService} from "../_services/auth.service";
import {Router} from "@angular/router";
import {FeedbackComponent} from "../shared/feedback/feedback.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
    selector: 'app-noAccess',
    templateUrl: './noAccess.component.html',
    styleUrl: './noAccess.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NoAccessComponent {
    contactEmail: string | undefined;

    constructor(private authService: AuthService,
                private router: Router,
                public dialog: MatDialog) {
        this.dialog.closeAll();
        if (!this.authService.isLoggedIn()) {
            //  LoginUser has token can go to auth view
            this.router.navigate(['/login']);
        }
        this.authService.getDynamicSettings().then((r): void => {
            this.contactEmail = r.contact_email;
        });
    }

    goToHome(): void {
        this.router.navigate(['/timeline']);
    }

    feedback(): void {
        if (this.dialog.openDialogs.length == 0) {
            this.dialog.open(FeedbackComponent);
        }
    }

    logout(): void {
        this.authService.logout();
    }
}
